import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export default withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "edit-page-layout-with-popup" */ './edit-page-layout-with-popup')
    ),
});
